/**
 * Місце форми «Повідомити про проблему» в застосунку (UX-51). У головному чанку лише ця тонка
 * оболонка: сама форма (`ReportDialog.tsx`, з компонентами форм і стилями) ліниво вантажиться при
 * відкритті. Хост стоїть поза роутером і кешем запитів, тож форма відкривається і зі збою оболонки.
 */
import { lazy, Suspense, useEffect } from 'react';
import { supportCore as t } from '../i18n/uk/support-core.ts';
import { toast } from '../ui/notify/index.ts';
import { RetryBoundary } from '../ui/RetryBoundary.tsx';
import { closeReport, useReportRequest } from './report.ts';

const loadDialog = () => import('./ReportDialog.tsx');
let ReportDialog = lazy(loadDialog);

/** Чанк форми не завантажився (стара вкладка після релізу, обрив): тост замість порожнього екрана. */
function LoadFailed() {
  useEffect(() => {
    // `lazy()` кешує відхилений імпорт до перезавантаження: новий, щоб повторне відкриття спробувало знову.
    ReportDialog = lazy(loadDialog);
    toast({ text: t.reportLoadFailed, tone: 'alert' });
    closeReport();
  }, []);
  return null;
}

export function ReportHost() {
  const request = useReportRequest();
  if (!request) return null;
  return (
    <RetryBoundary fallback={() => <LoadFailed />}>
      <Suspense fallback={null}>
        <ReportDialog request={request} onClose={closeReport} />
      </Suspense>
    </RetryBoundary>
  );
}
